export default function somethingWrong(customString?: string) {
  if (customString) {
    return console.error(customString)
  }

  return console.error(`🚨 Something is wrong here `)
}
